var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "exclusions" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "9" } },
                [
                  _c("h1", [_vm._v("Kein Interesse")]),
                  _vm._v(" "),
                  !_vm.loadingJobs
                    ? _c("Listing", {
                        attrs: {
                          jobs: _vm.jobs,
                          "loading-jobs": _vm.loadingJobs,
                          "with-head": false,
                          "only-excluded": true,
                          "force-listing": true
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }